module.exports = __webpack_public_path__ + "img/puberty-decal-14.6d01e999.png";